'use client';

import { useEffect, useState } from 'react';
import { Gift } from 'lucide-react';
import { priglashenieAction } from '@/app/[locale]/(product-auth)/priglashenie-actions';
import { TR, referalkaNaHoste } from '@/lib/referalka';

/**
 * Плашка на входе и регистрации: «Вы пришли по приглашению…».
 *
 * Появляется, только если сервер подтвердил и метку перехода, и то, что
 * программа включена. Пока ответа нет или он «нет», не рисуется ничего:
 * страница выглядит как без рефералки.
 */
export function PlashkaPriglasheniya() {
  const [pokazat, setPokazat] = useState(false);
  useEffect(() => {
    // На чужих доменах не спрашиваем сервер вовсе: рефералка только у aisearch.ru.
    if (!referalkaNaHoste(window.location.host)) return;
    let zhivo = true;
    void priglashenieAction().then((da) => {
      if (zhivo && da) setPokazat(true);
    });
    return () => {
      zhivo = false;
    };
  }, []);
  if (!pokazat) return null;
  return <PlashkaPriglasheniyaVid />;
}

/** Сама плашка, отдельно ради проверки разметки. */
export function PlashkaPriglasheniyaVid() {
  return (
    <div
      role="note"
      className="w-full max-w-md mb-4 flex items-start gap-3 rounded-xl border border-[var(--color-accent-500)]/40 bg-[var(--color-accent-500)]/5 px-4 py-3 text-sm"
    >
      <Gift className="w-5 h-5 shrink-0 text-[var(--color-accent-400)]" aria-hidden="true" />
      <p>{TR.plashka}</p>
    </div>
  );
}
